import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    step: false,
    plan: false,
    stripe_key: false,
    success_url: false,
    recipient_name: null,
    recipient_email: null,
    sender_name: null,
    sender_email: null,
    message: null,
    // recipient_name: 'Hop',
    // recipient_email: 'hop@hop.hp',
    // sender_name: 'Machin',
    // sender_email: 'me@me.com',
    // message: 'You gonna kiff a max !',
    coupon: false
  },
  mutations: {
    setPlan (state, plan) {
      state.plan = plan
    },
    setStripeKey (state, key) {
      state.stripe_key = key
    },
    setSuccessUrl (state, url) {
      state.success_url = url
    },
    setStep (state, step) {
      state.step = step
    },
    setSenderName (state, sender_name) {
      state.sender_name = sender_name
    },
    setSenderEmail (state, sender_email) {
      state.sender_email = sender_email
    },
    setRecipientName (state, recipient_name) {
      state.recipient_name = recipient_name
    },
    setRecipientEmail (state, recipient_email) {
      state.recipient_email = recipient_email
    },
    setMessage (state, message) {
      state.message = message
    },
  }
})
